import * as types from './actionTypes';

export const fetchJobSetupQualifications = (unit_id) => ({
  type: types.FETCH_JOB_SETUP_QUALIFICATIONS_REQUEST,
  payload: { unit_id },
});

export const saveJobSetupQualification = (data) => ({
  type: types.SAVE_JOB_SETUP_QUALIFICATION_REQUEST,
  payload: data,
});

export const changeJobSetupQualificationStatus = (payload) => ({
  type: types.CHANGE_JOB_SETUP_QUALIFICATION_STATUS_REQUEST,
  payload,
});